import { PreventEventForPreviouslyShownModals } from "./is-modal-the-currently-shown-modal"
import { IsTheSameElementClickInterruption } from "./outside-click"

export const Interruptions = [new PreventEventForPreviouslyShownModals(), new IsTheSameElementClickInterruption()]
